import React from 'react'
import Redirect, { HttpStatusCodes } from '#src/components/Redirect'
import { UserLoginTokenComponent } from '#src/generated/graphql'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { FullBlockLoader, CircleLoader } from '@deal/components'
import { HostnameConsumer, Hostname } from '#src/containers/Hostname'

interface CuratedRedirectProps extends RouteComponentProps<{}> {}

const CuratedRedirect: React.SFC<CuratedRedirectProps> = ({ history }) => {
  return (
    <HostnameConsumer>
      {hostname => (
        <>
          {hostname === Hostname.Deal && (
            <UserLoginTokenComponent>
              {({ data, loading }) => {
                if (loading) {
                  return <FullBlockLoader loader={CircleLoader} />
                }

                const loginToken = data && data.me ? data.me.loginToken : undefined
                const existingSearchParams = new URLSearchParams(history.location.search)

                if (loginToken) {
                  existingSearchParams.append('lt', loginToken)
                }

                return (
                  <Redirect
                    to={{
                      pathname: history.location.pathname,
                      search: existingSearchParams.toString()
                    }}
                    ignoreSearchParams={true}
                    statusCode={HttpStatusCodes.MOVED_PERMANENTLY}
                  />
                )
              }}
            </UserLoginTokenComponent>
          )}
        </>
      )}
    </HostnameConsumer>
  )
}
export default withRouter(CuratedRedirect)
